// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__3v6Qz","bigColWidth":"Table_bigColWidth__2rcGS","biggerColWidth":"Table_biggerColWidth__38meW","row":"Table_row__1E0_C","col":"Table_col__3LHSL"};